
import React, { useState, useEffect, useMemo } from 'react';
import { isIOS, isMobile, isTablet, MobileView } from 'react-device-detect';

import apiClient from '../../_utils/axios';
import Store from 'store';
import { ContentsWrap } from '../Common';
import { BlockTitle, BannerBox, BlockMore, BoxOver, BoxInImage } from '../HomePage';

const isMobileView = (isMobile && !(isIOS && isTablet));

export const Partner = ({ main_title_6_ko, main_title_6_en }) => {
  const [data, setData] = useState([]);

  const homePartnerList = async () => {
    try {
      const res = await apiClient.get(`/web/banner?type=partner`);

      if (res) {
        setData(res.data);
      }
    } catch (error) {
      console.error('Failed to fetch new design list:', error);
    }
  };

  useEffect(() => {
    homePartnerList();
  }, []); // Runs once when the component mounts



  return (<ContentsWrap style={{ marginTop: '1vw', marginBottom: '2vw' }}>
  <div style={{ marginTop: '1vw' }}>
    <BlockTitle>{Store.get('lang') === 'kr' ? main_title_6_ko : main_title_6_en}</BlockTitle>
  </div>
  <BannerBox
    style={{
      marginTop: '1vw',
      position: 'relative',
    }}>
    <BoxInImage
      style={{
        backgroundImage: `url(${process.env.REACT_APP_S3_BUCKET_DOMAIN}${(data.length > 0) && isMobileView
          ? data[0].banner_mob_img
          : data.length > 0 && !isMobileView
            ? data[0].banner_img
            : ''
          })`,
      }}
    />
  </BannerBox>
</ContentsWrap>)
};
export default Partner;